import { render, staticRenderFns } from "./OverlayInvestOrderButton.vue?vue&type=template&id=65b84e2a&scoped=true&"
import script from "./OverlayInvestOrderButton.vue?vue&type=script&lang=js&"
export * from "./OverlayInvestOrderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b84e2a",
  null
  
)

export default component.exports